import { render, staticRenderFns } from "./ModalReport.vue?vue&type=template&id=27823dcc"
import script from "./ModalReport.vue?vue&type=script&lang=js"
export * from "./ModalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports